export default {
  'activation-bar': {
    'info': 'Use Turn Tracker to distribute your appointments, services, and revenue evenly across your available Staff Members.',
    'action-button': 'Activate Turn Tracker',
  },
  'advanced-options': {
    'title': 'Turn tracker',
    'description': 'Turn Tracker is a staff management tool that helps you evenly assign appointments to your staff throughout the day, or decide who gets the next “turn”.<br/><br/>Based on the mode you select, this tool will suggest which employee or technician should get the next appointment or client. You control how appointments are distributed, and you can always make changes to the calendar or assignments as needed.<br/><br/>You choose how turns are decided:<br/><br/><strong>Queue Rotation</strong> - the simplest mode - clients are assigned to staff one by one in basic order of who is next<br/><br/><strong>Service Mode</strong> - evenly distribute appointments based on the number of services performed by each staff member<br/><br/><strong>Sales Mode</strong> - distribute appointments based on the total cost of services performed by each staff member (for even commissions at the end of the day)<br/><br/>Activate Turn Tracker to automatically keep track of employees’ turns throughout the day, and suggest who the next client should be assigned to.',
    'activated': 'Activated',
    'inactive': 'Inactive',
    'deactivate': 'Deactivate',
  },
  'activation-modal': {
    'title': 'Activate Turn Tracker?',
    'description': 'Turn Tracker is a staff management tool that helps you evenly assign appointments to your staff throughout the day, or decide who gets the next “turn”.<br/><br/>Based on the mode you select, this tool will suggest which employee or technician should get the next appointment or client. You control how appointments are distributed, and you can always make changes to the calendar or assignments as needed.<br/><br/>Activate Turn Tracker to automatically keep track of employees’ turns throughout the day, and suggest who the next client should be assigned to.',
    'action-button': 'Activate Turn Tracker',
    'notification-success': 'Turn Tracker activated',
  },
  'deactivation-modal': {
    'title': 'Deactivate Turn Tracker?',
    'description': 'Are you sure you want to deactivate Turn Tracker? All Staff Members will be removed from availability and turns will not be assigned until Turn Tracker is activated.',
    'confirm-button': 'Deactivate Turn Tracker',
    'notification-success': 'Turn Tracker deactivated',
  },
  'staff-managment': {
    'title': 'Manage Staff · {today} · Today',
    'not-working-today': 'Not working today',
    'staff-member-working-hours': 'Staff Member Working Hours',
    'drag-and-drop-here': 'Drag and drop here',
    'turns': 'T',
    'revenue': 'R',
    'search': 'Search staff member',
    'checked-in': 'Checked in',
    'staff-members-available': 'Available staff members',
    'check-in': 'Check in',
    'check-out': 'Check out',
    'check-in-all': 'Check in all',
    'check-out-all': 'Check out all',
    'drag-and-drop-prompt': 'Drag and drop to change order',
    'check-in-modal-title': 'Check in all staff members?',
    'check-out-modal-title': 'Check out all staff members?',
    'check-in-modal-description': 'Turns will be assigned based on staff member availability. Make sure all staff members are ready to start turns before you confirm check-in. This action can\'t be undone.',
    'check-out-modal-description': 'Turns won\'t be assigned to staff members marked as unavailable. Are you sure you want to check out all staff members? This action can\'t be undone.',
    'empty-unavailable': 'No Available Staff Members',
    'empty-available': 'No checked-in staff members',

  },
  'tile': {
    'full-turn': 'FT',
    'half-turn': 'HT',
    'manual-turn': 'Bonus Full Turn',
    'new-full-turn': 'Full Turn',
    'new-half-turn': 'Half Turn',
    'turn': 'T',
    'next': 'Next',
    'busy': 'Busy',
    'in-progress': 'In progress',
    'time-off': 'Time off',
    'penalty': 'Penalty',
    'new-penalty': 'Penalty Turn',
    'settle': 'Settle',
    'loyalty': 'Loyalty',
    'actions': {
      'start-turn': 'Start turn',
      'add-penalty-turn': 'Penalty turn',
      'add-extra-turn': 'Manual turn',
      'remove-penalty-turn': 'Remove penalty turn',
      'remove-extra-turn': 'Remove manual turn',
      'simple-checkout': 'Finish turn',
      'checkout': 'Finish Turn • Checkout',
      'edit-turn': 'Edit turn',
      'appointment': 'Appointment',
    },
  },
  'pill': {
    'upcoming-time-off': 'Time Off',
    'upcoming-busy': 'Busy',
    'scheduled': 'Scheduled',
  },
  'finish-turn': {
    'finish-turn': 'Finish turn',
    'edit-turn': 'Edit turn',
    'turn-value-at-checkout': 'Turn Value At Checkout',
  },
  'dashboard': {
    'title': '{today} · Today',
    'available-staff': 'Available staff',
    'turns-grid': 'Turns grid',
    'grid-key': 'Help',
    'manage': 'Manage',
    'checkout': 'Checkout',
    'filter-staff-by': 'Filter staff by',
    'not-selected': 'Not selected',
    'turns': 'T',
    'revenue': 'R',
    'busy': 'Busy',
    'available': 'Available',
    'manage-actions': {
      'manage-staff': 'Manage Staff',
      'settings': 'Settings',
      'staff-commissions': 'Staff commissions',
      'stats-and-reports': 'Stats & Reports',
    },
    'no-available-staffers': {
      'no-staffers-checked-in': {
        'title': 'No Staff Members Available',
        'subtitle': 'Make sure to update staff availability as soon as they come to work. Based on this, staff members will be assigned turns.',
      },
      'no-staffers-performing': {
        'title': 'Which Staff Members are available?',
        'subtitle': 'Staff members performing the selected service are currently not available | Staff members performing selected services are currently not available',
      },
      'description': 'Choose Manage Staff to select which Staff Members are ready to be assigned a turn.',
      'manage-staff': 'Update staff availability',
    },
    'next': {
      'title': 'Who’s up next?',
      'description-1': 'To find which Staff Member will be assigned the next turn, look for the tile marked NEXT.',
      'description-2': 'If no tile is marked NEXT, see which appointments are complete and click Checkout to make that Staff Member available again.',
    },
  },
  'settings': {
    'title': 'Settings',
    'tabs': {
      'mode': 'Turn Tracker Mode',
      'manual': 'Manual Turns',
      'automated': 'Advanced Settings',
    },
    'staff-mode': {
      'label': 'Keep it simple',
      'title': 'Queue Rotation',
      'description': 'Assign turns to Staff Members in the order they appear on the Available Staff list. The next Staff Member on the list will be assigned the next turn regardless of revenue or completed turns.',
    },
    'service-mode': {
      'label': 'Keep it even',
      'title': 'Service Mode',
      'description': 'Assign an equal number of turns to each Staff Member regardless of revenue. The next turn will be assigned based on how many completed turns each Staff Member has.',
    },
    'revenue-mode': {
      'label': 'Keep it fair',
      'title': 'Sales Mode',
      'full-value': 'Full Value',
      'minimum-value': 'Minimum Value',
      'negative-value-error': 'Turn value cannot be negative',
      'greater-than-zero-error': 'Turn value must be greater than 0',
      'description': 'Assign equal revenue to each Staff Member. The next turn will be assigned to the Staff Member with the lowest revenue earned, regardless of the number of completed turns. You must set the Full Value for a turn to use Sales Mode.',
      'set-a-minimum': {
        'title': 'Set a Minimum',
        'description': 'Require appointments to meet a Minimum Value in order to count as a turn and be included in the revenue. Appointments that cost between the Minimum Value and the Full Value will be assigned as Half Turns. ',
      },
      'multiple-full-turns': {
        'title': 'Earn Multiple Full Turns',
        'description': 'Assign multiple Full Turns to a Staff Member when the services they\'re completing cost more than the Full Value.',
      },
      'merge-half-turns': {
        'title': 'Merge Half Turns',
        'description': 'Streamline your Turns Grid by merging completed Half Turns together into one tile on the grid. The sum of the revenue for the Half Turns will appear on the tile. ',
      },
    },
    'manual': {
      'title': 'Make Changes to Turns Manually',
      'description': 'Allow employees with a Permission level of Owner, Manager, or Reception to make select changes to how turns are assigned.',
      'void-turn': {
        'title': 'Penalty Turn',
        'description': 'No service will be assigned to the Staff Member and no revenue will be earned for this turn. This may result in a lower number of completed turns or lower revenue than other Staff Members.',
      },
      'bonus-turn': {
        'title': 'Manual Turn',
        'description': 'An additional turn can be assigned to a Staff Member. This may result in a higher number of completed turns or higher revenue than other Staff Members.',
      },
    },
    'automated': {
      'loyalty-turn': {
        'title': 'Add Loyalty Turn',
        'description': 'Reward Staff Members with an extra turn when a returning customer books another appointment with them.',
      },
      'customer-information-reminder': {
        'title': 'Ask for Client Information',
        'description': 'For clients who are not on your clients list, you’ll be asked to fill in client information every time you add an appointment.',
      },
      'schedule-appointments': {
        'title': 'Include Scheduled Appointments and/or Revenue',
        'description': 'Scheduled appointments for any time during their shift will be included in the total turns and revenue for each Staff Member.',
      },
      'avoid-scheduled-conflicts': {
        'title': 'Avoid Schedule Conflicts',
        'description': 'Turns may be assigned to Staff Members out of order to avoid upcoming schedule conflicts such as scheduled appointments or break time.',
      },
      'display-revenue': {
        'title': 'Display Revenue',
        'description': 'Revenue for each Staff Member will be displayed on the Turns Grid (R:).',
      },
      'appointment-checkout': {
        'title': 'Require Appointment Checkout',
        'description': 'Checkout will be required to finish a Turn. Disable this option for a simplified process of finishing Turns.',
      },
    },
    'update-checkout-settings': {
      'title': 'Update checkout settings?',
      'description': 'If you update this setting, you may need to check out today’s appointments again. Are you sure you want to continue?',
      'action': 'Update checkout settings',
    },
  },
  'checkout': {
    'paid': {
      'btn-turn-tracker': 'Go back to Turn Tracker',
    },
  },
  'how-it-works-redesign': {
    'grid-key': {
      'title': 'Help',
      'content': {
        'add-turn-heading': 'Add Turn',
        'add-turn-text': 'Click the Add Turn tile to schedule a turn. Turns added using this option will be included in the Turn Tracker queue.',
        'busy-heading': 'In progress',
        'busy-text': 'Turns that are currently in progress.',
        'full-and-half-turns-heading': 'Full and Half Turns',
        'full-and-half-turns-text': 'In the Sales Mode mode, you can set the threshold value of the Full Turn Value (FT) and optionally Minimum Turn Value. The service priced less than the threshold will be counted as Half-Turn. The service priced less than minimum turn value will not be counted as a turn (it is free of turn dedicated for small services) although it will be included into today’s revenue count.',
        'penalty-turns-heading': 'Penalty Turns',
        'penalty-turns-text': 'Turns that a Staff Member will not be assigned a service, appointment, or revenue for. May result in loss of revenue.',
        'time-off-heading': 'Time Off',
        'time-off-text': 'Time off is a placeholder tile that marks time slots when a Staff Member is not available, to keep your schedule running smoothly.',
        'next-marker-heading': 'Next',
        'next-marker-text': 'The Next label indicates the Staff Member who will be assigned the next turn.',
        'busy-upcoming-heading': 'Busy (upcoming)',
        'busy-upcoming-text': 'The Busy label indicates that the Staff Member has an upcoming appointment soon.',
        'scheduled-turns-heading': 'Scheduled (upcoming)',
        'scheduled-turns-text': 'The Scheduled label indicates that an appointment with this Staff Member has been scheduled ahead of time, e.g. booked online or added to their calendar in Booksy.',
        'time-off-upcoming-heading': 'Time off (upcoming)',
        'time-off-upcoming-text': 'The Time off label indicates the scheduled time off for this Staff Member.',
      },
    },
    'staff-mode': {
      'title': 'How does Staff Mode work?',
      'content': {
        'heading': 'Staff Mode',
        'text': 'Each turn is assigned to the next Staff Member on the Available Staff list, regardless of the value of the service, the number of services, or the number of turns the Staff Member has.<br /><br />No matter what, the turn is assigned in order of the Available Staff list.<br /><br />Use this mode if most of your services take the same approximate time to complete and all of your Staff Members are able to complete all services.<br /><br />Full Value and Minimum Value for don\'t need to be set to use this mode.',
      },
    },
    'service-mode': {
      'title': 'How does Service Mode work?',
      'content': {
        'heading': 'Service Mode',
        'text': 'Turns are assigned to evenly distribute the number of services across Staff Members, regardless of the value of the service.<br /><br />Staff Members will get an equal number of turns, although the revenue they earn for each service may vary.<br /><br />Use this mode if most of your services have the same approximate cost and all your Staff Members are able to complete all services.<br /><br />Full Value and Minimum Value for turns don\'t need to be set to use this mode.',
      },
    },
    'revenue-mode': {
      'title': 'How does Revenue Mode work?',
      'content': {
        'heading': 'Revenue Mode',
        'text': 'Turns are assigned to evenly distribute revenue across Staff Members. In this mode, turns are based on the value of the services being provided.<br /><br />Use this mode if the cost of your services varies and Staff Members are only able to complete certain services.<br /><br />Set the Full Value for a turn to define how much revenue must be earned to be counted as a Full Turn.<br /><br />Set the Minimum Value for a turn to define how much revenue must be earned in order to be counted as a Turn at all.<br /><br />Services that cost between the Minimum Value and Full Value for a turn will be counted as Half Turns.',
      },
    },
    'minimum-value': {
      'title': 'How does Set a Minimum work?',
      'content': {
        'heading': 'Minimum Value',
        'text': 'Set a Minimum Value to define how much an appointment must cost to be counted as a turn and included in the revenue. If an appointment costs less than the Minimum Value, a turn will not be assigned and the appointment value will not be included in the revenue.<br /><br />Appointments that cost between the Minimum Value and the Full Value will be assigned as Half Turns.',
      },
    },
    'merge-half-turns': {
      'title': 'How does Merge Half Turns work?',
      'content': {
        'heading': 'Merge Half Turns',
        'text': 'Streamline your Turns Grid by merging completed Half Turns together into one tile on the grid.<br /><br />When a Staff Member has been assigned two Half Turns for separate services, they\'ll automatically be combined into one tile in the Turn Grid. The revenue that appears on the tile will be the sum of the two Half Turns.',
      },
    },
    'multiple-full-turns': {
      'title': 'How does Earn Multiple Full Turns work?',
      'content': {
        'heading': 'Earn Multiple Full Turns',
        'text': 'Staff Members may be assigned multiple Full Turns for one appointment based on the total cost.<br /><br />If the cost is higher than the Full Value for a turn that you\'ve set, the Staff Member would be assigned more than one Full Turn.<br /><br />For example, if you set the Full Value of a turn as {turnValue} and a Staff Member performs services that cost a total of {servicesValue}, then the Staff Member would be assigned five Full Turns.',
      },
    },
    'manual-turn-bonus-tile': {
      'title': 'How does Add Bonus Turn work?',
      'content': {
        'heading': 'Bonus Turn',
        'text': 'Employees with permissions set as Manager, Owner, or Reception can manually add a Full Turn for a Staff Member.<br /><br />This will allow the Staff Member to be assigned an additional Full Turn, which may mean that they complete more turns or earn more revenue than other Staff Members.<br /><br />A Bonus Turn can be removed at any time by someone with Manager, Owner, or Reception permissions.<br /><br />Use this as an incentive, to even out an imbalance in turns, or in any way that works for your business.',
      },
    },
    'manual-turn-void-tile': {
      'title': 'How does Penalty Turn work?',
      'content': {
        'heading': 'Penalty Turn',
        'text': 'Employees with permissions set as Manager, Owner, or Reception can remove a Full Turn from a Staff Member at any time.<br /><br />When a Penalty Turn is assigned, the Staff Member will not complete a service and not earn any revenue for that turn.<br /><br />A Penalty Turn can be removed at any time by someone with permissions set as Manager, Owner, or Reception. If removed, the Staff Member will be able to complete a service or appointment and earn revenue for that turn.<br /><br />Use this to enforce a penalty, to even out an imbalance in turns, or for whatever works for your business.',
      },
    },
    'automated-loyalty-turn': {
      'title': 'How does Add Loyalty Turn work?',
      'content': {
        'heading': 'Loyalty Turn',
        'text': 'Reward your Staff Members for offering excellent service and nurturing loyal relationships with customers.<br /><br />An additional turn will be automatically added for a Staff Member when a returning customer books another appointment with them.<br /><br />This may mean that they complete more turns or earn more revenue than other Staff Members.<br /><br />If you prefer to add additional turns manually, disable Add Loyalty Turn and go to Manual Turns to enable Bonus Turn instead.',
      },
    },
    'automated-customer-information-reminder': {
      'title': 'How does Ask for Client Information work?',
      'content': {
        'heading': 'Ask for Client Information',
        'text': 'Every time you add an appointment and leave the client field blank, you’ll be prompted to fill in basic client information such as name and contact details. Once you do it, the person will be added to your client list.<br /><br />You might want to disable the option if your clients are mostly walk-ins and you don’t need to add them to your client base in Booksy.',
      },
    },
    'automated-scheduled-appointment': {
      'title': 'How does Scheduled work in Sales mode?',
      'content': {
        'heading': 'Include Scheduled Services and/or Revenue',
        'text': 'The Scheduled label on your Turns Grid means that this Staff Member has an appointment planned which has either been booked online or added in the Booksy calendar.<br /><br />In Sales mode, appointments scheduled for later in the day are also included in the total revenue. So if a Staff Member has some appointments scheduled, their turn might be skipped so that revenue is distributed evenly.',
      },
    },
    'automated-display-revenue': {
      'title': 'How does Display Revenue work?',
      'content': {
        'heading': 'Display Revenue',
        'text': 'Display the total revenue earned for each Staff Member and each turn on the Turns Grid.<br /><br />Staff Member revenue will appear next to their name as R: and may include revenue from scheduled appointments that have not been completed yet.<br /><br />Turn revenue will appear on each tile. Revenue for Half Turns that have been merged into a single time may only show the sum total of the two Half Turns. <br /><br />If you don\'t want revenue to be visible on the Turns Grid, disable this feature. Staff Member revenue will still be tracked and will appear in Stats & Reports.',
      },
    },
    'automated-appointment-checkout': {
      'title': 'How does Require Appointment Checkout work?',
      'content': {
        'heading': 'Require Appointment Checkout',
        'text': 'With this setting enabled, full Appointment Checkout will be required in order to consider a Turn completed.<br /><br />Disable this option if you want to simplify the process. Instead of the regular Checkout process, you will be prompted to confirm the final Turn value in order to complete a Turn.',
      },
    },
    'automated-avoid-schedule-conflicts': {
      'title': 'How does Avoid Schedule Conflicts work?',
      'content': {
        'heading': 'Avoid Schedule Conflicts',
        'text': 'If the Staff Member who would have been assigned the next turn has a conflict in their schedule within the set amount of time, the turn will be assigned to the next Staff Member.<br /><br />If the Staff Member with the schedule conflict is behind in turns or revenue when they become available again, they will be assigned turns to get them caught up with the rest of the Staff.<br /><br />Set the timeframe for schedule conflicts to 15, 30, 45, or 60 minutes. If a scheduled appointment, break time, or time off is scheduled to start within that time frame, that turn will be reassigned.<br /><br />This is not meant to be a penalty for the Staff Member with the schedule conflict. The purpose is to help you keep your schedule running smoothly.',
      },
    },
  },
  'how-it-works': {
    'grid-key': {
      'title': 'Grid key',
      'content': {
        'scheduled-turns-heading': 'Scheduled Turns',
        'scheduled-turns-text': 'Turns that correspond to appointments that have been scheduled ahead of time.',
        'settled-turns-heading': 'Settled Turns',
        'settled-turns-text': 'Appointments that are done. The service is finished, the client has paid, and Checkout was completed.',
        'void-turns-heading': 'Penalty Turns',
        'void-turns-text': 'Turns that a Staff Member will not be assigned a service, appointment, or revenue for. May result in loss of revenue.',
        'full-and-half-turns-heading': 'Full and Half Turns',
        'full-and-half-turns-text': 'In the Sales Mode mode, you can set the threshold value of the Full Turn Value (FT) and optionally Minimum Turn Value. The service priced less than the threshold will be counted as Half-Turn. The service priced less than minimum turn value will not be counted as a turn (it is free of turn dedicated for small services) although it will be included into today’s revenue count.',
        'turn-tracker-turns-heading': 'Empty, Next, Busy, and Time off',
        'turn-tracker-turns-text': 'These tiles represent an empty tile. They may contain markers for BUSY, TIME OFF, or NEXT. Select an empty tile to start a turn. Depending on your Settings, you may also be able to manually enter a Penalty Turn or Manual Turn. An empty tile has not been assigned a turn. It may have markers like NEXT, BUSY, or TIME OFF that act as placeholders to keep your schedule running smoothly.',
        'schedule-conflict-heading': 'Schedule Conflict Icon',
        'schedule-conflict-text': 'This icon appears when Avoid Schedule Conflicts is enabled. It indicates that a scheduled appointment, break time, or time off will start within the time limit you set.',
        'loyalty-turn-heading': 'Loyalty Turn Icon',
        'loyalty-turn-text': 'This icon will appear when Add Loyalty Turn is enabled. It indicates that a returning customer booked an appointment with a Staff Member again, so the Staff Member was rewarded with an additional turn.',
        'manual-edit-heading': 'Manual Edit Icon',
        'manual-edit-text': 'This icon will appear on tiles that represent Penalty Turns and Manual Turns that were manually added by someone with Permissions set as Manager, Owner, or Reception.',
      },
    },
    'staff-mode': {
      'title': 'How does Queue Rotation work?',
      'content': {
        'heading': 'Queue Rotation',
        'text': 'Each turn is assigned to the next Staff Member on the Available Staff list, regardless of the value of the service, the number of services, or the number of turns the Staff Member has.<br /><br />No matter what, the turn is assigned in order of the Available Staff list.<br /><br />Use this mode if most of your services take the same approximate time to complete and all of your Staff Members are able to complete all services.<br /><br />Full Value and Minimum Value for don\'t need to be set to use this mode.',
      },
    },
    'service-mode': {
      'title': 'How does Service Mode work?',
      'content': {
        'heading': 'Service Mode',
        'text': 'Turns are assigned to evenly distribute the number of services across Staff Members, regardless of the value of the service.<br /><br />Staff Members will get an equal number of turns, although the revenue they earn for each service may vary.<br /><br />Use this mode if most of your services have the same approximate cost and all your Staff Members are able to complete all services.<br /><br />Full Value and Minimum Value for turns don\'t need to be set to use this mode.',
      },
    },
    'revenue-mode': {
      'title': 'How does Sales Mode work?',
      'content': {
        'heading': 'Sales Mode',
        'text': 'Turns are assigned to evenly distribute revenue across Staff Members. In this mode, turns are based on the value of the services being provided.<br /><br />Use this mode if the cost of your services varies and Staff Members are only able to complete certain services.<br /><br />Set the Full Value for a turn to define how much revenue must be earned to be counted as a Full Turn.<br /><br />Set the Minimum Value for a turn to define how much revenue must be earned in order to be counted as a Turn at all.<br /><br />Services that cost between the Minimum Value and Full Value for a turn will be counted as Half Turns.',
      },
    },
    'minimum-value': {
      'title': 'How does Set a Minimum work?',
      'content': {
        'heading': 'Minimum Value',
        'text': 'Set a Minimum Value to define how much an appointment must cost to be counted as a turn and included in the revenue. If an appointment costs less than the Minimum Value, a turn will not be assigned and the appointment value will not be included in the revenue.<br /><br />Appointments that cost between the Minimum Value and the Full Value will be assigned as Half Turns.',
      },
    },
    'multiple-full-turns': {
      'title': 'How does Earn Multiple Full Turns work?',
      'content': {
        'heading': 'Earn Multiple Full Turns',
        'text': 'Staff Members may be assigned multiple Full Turns for one appointment based on the total cost.<br /><br />If the cost is higher than the Full Value for a turn that you\'ve set, the Staff Member would be assigned more than one Full Turn.<br /><br />For example, if you set the Full Value of a turn as {turnValue} and a Staff Member performs services that cost a total of {servicesValue}, then the Staff Member would be assigned five Full Turns.',
      },
    },
    'merge-half-turns': {
      'title': 'How does Merge Half Turns work?',
      'content': {
        'heading': 'Merge Half Turns',
        'text': 'Streamline your Turns Grid by merging completed Half Turns together into one tile on the grid.<br /><br />When a Staff Member has been assigned two Half Turns for separate services, they\'ll automatically be combined into one tile in the Turn Grid. The revenue that appears on the tile will be the sum of the two Half Turns.',
      },
    },
    'manual-turn-bonus-tile': {
      'title': 'How does Add Manual Turn work?',
      'content': {
        'heading': 'Manual Turn',
        'text': 'Employees with permissions set as Manager, Owner, or Reception can manually add a Full Turn for a Staff Member.<br /><br />This will allow the Staff Member to be assigned an additional Full Turn, which may mean that they complete more turns or earn more revenue than other Staff Members.<br /><br />A Manual Turn can be removed at any time by someone with Manager, Owner, or Reception permissions.<br /><br />Use this as an incentive, to even out an imbalance in turns, or in any way that works for your business.',
      },
    },
    'manual-turn-void-tile': {
      'title': 'How does Penalty Turn work?',
      'content': {
        'heading': 'Penalty Turn',
        'text': 'Employees with permissions set as Manager, Owner, or Reception can remove a Full Turn from a Staff Member at any time.<br /><br />When a Penalty Turn is assigned, the Staff Member will not complete a service and not earn any revenue for that turn.<br /><br />A Penalty Turn can be removed at any time by someone with permissions set as Manager, Owner, or Reception. If removed, the Staff Member will be able to complete a service or appointment and earn revenue for that turn.<br /><br />Use this to enforce a penalty, to even out an imbalance in turns, or for whatever works for your business.',
      },
    },
    'automated-loyalty-turn': {
      'title': 'How does Add Loyalty Turn work?',
      'content': {
        'heading': 'Loyalty Turn',
        'text': 'Reward your Staff Members for offering excellent service and nurturing loyal relationships with customers.<br /><br />An additional turn will be automatically added for a Staff Member when a returning customer books another appointment with them.<br /><br />This may mean that they complete more turns or earn more revenue than other Staff Members.<br /><br />If you prefer to add additional turns manually, disable Add Loyalty Turn and go to Manual Turns to enable Manual Turn instead.',
      },
    },
    'automated-customer-information-reminder': {
      'title': 'How does Customer Information Reminder work?',
      'content': {
        'heading': 'Customer Information Reminder',
        'text': 'Collecting client information allows you to stay in contact with them, send a message when it\'s time to book another appointment, and build loyalty.<br /><br />Make sure your Staff Members are taking this crucial step by adding a reminder when they start a turn for a walk-in client.<br /><br />The reminder will appear each time a turn is started for a walk-in client, and will give your Staff Members the option to enter client information or skip this step.<br /><br />If building client loyalty isn’t a priority for your business, disable this reminder.',
      },
    },
    'automated-sheduled-appointment': {
      'title': 'How does Include Scheduled Appointments and/or Revenue?',
      'content': {
        'heading': 'Include Scheduled Services and/or Revenue',
        'text': 'Automatically include any appointments that have been scheduled with Staff Members in their Turns (T:) and Revenue (R:) on the Turns Grid.<br /><br />For example, if a Staff Member has a manicure with an estimated value of {turnValue} scheduled for later that day, the Turns Grid would show T:1 R:{turnValue} next to their name when they start their shift.<br /><br />If the scheduled appointment is cancelled or rescheduled, their Turns and Revenue will be adjusted automatically.<br /><br />We recommend enabling this feature if your business frequently has appointments scheduled ahead of time.',
      },
    },
    'automated-avoid-schedule-conflicts': {
      'title': 'How does Avoid Schedule Conflicts work?',
      'content': {
        'heading': 'Avoid Schedule Conflicts',
        'text': 'If the Staff Member who would have been assigned the next turn has a conflict in their schedule within the set amount of time, the turn will be assigned to the next Staff Member.<br /><br />If the Staff Member with the schedule conflict is behind in turns or revenue when they become available again, they will be assigned turns to get them caught up with the rest of the Staff.<br /><br />Set the timeframe for schedule conflicts to 15, 30, 45, or 60 minutes. If a scheduled appointment, break time, or time off is scheduled to start within that time frame, that turn will be reassigned.<br /><br />This is not meant to be a penalty for the Staff Member with the schedule conflict. The purpose is to help you keep your schedule running smoothly.',
      },
    },
    'automated-display-revenue': {
      'title': 'How does Display Revenue work?',
      'content': {
        'heading': 'Display Revenue',
        'text': 'Display the total revenue earned for each Staff Member and each turn on the Turns Grid.<br /><br />Staff Member revenue will appear next to their name as R: and may include revenue from scheduled appointments that have not been completed yet.<br /><br />Turn revenue will appear on each tile. Revenue for Half Turns that have been merged into a single tile may only show the sum total of the two Half Turns.<br /><br />If you don\'t want revenue to be visible on the Turns Grid, disable this feature. Staff Member revenue will still be tracked and will appear in Stats & Reports.',
      },
    },
    'automated-appointment-checkout': {
      'title': 'How does Require Appointment Checkout work?',
      'content': {
        'heading': 'Require Appointment Checkout',
        'text': 'With this setting enabled, full Appointment Checkout will be required in order to consider a Turn completed.<br /><br />Disable this option if you want to simplify the process. Instead of the regular Checkout process, you will be prompted to confirm the final Turn value in order to complete a Turn.',
      },
    },
  },
}
